import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import FooterSection from '../../components/Footer/Footer';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import BusModifySearch from '../../components/BusModifySearch/BusModifySearch';
import StaticPageHeader from '../../components/StaticPageHeader/StaticPageHeader';
import Pagination from '../../components/Pagination';
import { ThrowReporter } from 'io-ts/lib/ThrowReporter';
import { PathReporter } from 'io-ts/lib/PathReporter';
import {
  StaticListIndexSingleChecker,
  StaticListIndexSingleData
} from './BusCityIndexDataTypeChecker';
import { EnvironmentVariables } from '../../types';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import { getAppEnv } from '../../../config/env';
import '../../styles/StaticListIndex.css';
import { RouteComponentProps } from 'react-router-dom';
const env = getAppEnv();
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;

type PathParamsType = {
  letter: string;
  page: string;
};

type StaticListIndexSingleProps = RouteComponentProps<PathParamsType> & {
  data: StaticListIndexSingleData;
};
const runtimeTypChecker = (data: StaticListIndexSingleData) => {
  const result = StaticListIndexSingleChecker.decode(data);
  if (result._tag !== 'Right') {
    // console.log(PathReporter.report(result))
    ThrowReporter.report(result);
  }
};
const StaticListIndexSingle = ({ data }: StaticListIndexSingleProps) => {
  runtimeTypChecker(data);
  const [collapsableFlag, setcollapsableFlag] = useState(true);
  const [fromCity, setFromCity] = useState('');
  const [toCity, setToCity] = useState('');
  const [fromCode, setFromCode] = useState('');
  const [toCode, setToCode] = useState('');
  const [widget, setWidget] = useState<null | number>(null);

  const onFromChange = (city: string, code: string) => {
    setFromCity(city);
    setFromCode(code);
    // trackCityTemplateEvent(`Bus_SEO_From_Select`)
  };

  const onToChange = (city: string, code: string) => {
    setToCity(city);
    setToCode(code);
    // trackCityTemplateEvent(`Bus_SEO_To_Select`)
  };

  const alphabets = [...'abcdefghijklmnopqrstuvwxyz'];
  const urlPrefix = `city-index`;

  return (
    <>
      {/* <div className={`busSeoPage ${collapsableFlag ? '' : 'expanded'}`}> */}
      <div className={`busSeoPage`}>
        <div className="">
          <Helmet>
            <title>{data.templateData.metaTitle}</title>
          </Helmet>
          <div className={`desktopShow makeSticky`}>
            <BusModifySearch
              sourceCityName={``}
              widget={widget}
              setWidget={setWidget}
              onFromChange={onFromChange}
              onToChange={onToChange}
              fromCity={fromCity}
              toCity={toCity}
              fromCode={fromCode}
              toCode={toCode}
              setcollapsableFlag={setcollapsableFlag}
              collapsableFlag={collapsableFlag}
              isMobileDevice={false}
              demoLink={true}
            />
          </div>
          <div className={`mobileShow makeSticky`}>
            <BusModifySearch
              sourceCityName={``}
              widget={widget}
              setWidget={setWidget}
              onFromChange={onFromChange}
              onToChange={onToChange}
              fromCity={fromCity}
              toCity={toCity}
              fromCode={fromCode}
              toCode={toCode}
              setcollapsableFlag={setcollapsableFlag}
              collapsableFlag={collapsableFlag}
              isMobileDevice={true}
              demoLink={true}
            />
          </div>
          <br />
          <br />
          <main>
            <div className="busSeoWrapper">
              <BreadCrumb breadcrumb={data.templateData.breadcrumb} />

              <StaticPageHeader title={data.templateData.h1Title} />
              <br />
              <div className="busSeoWrap__cityIndexLetters">
                {alphabets.map(letter => (
                  <a
                    onClick={() => {
                      // trackCityTemplateEvent(``)
                    }}
                    key={`${letter}`}
                    href={`${urlPrefix}_${letter}_1.html`}
                    className="primaryBtn"
                  >
                    {letter.toUpperCase()}
                  </a>
                ))}
              </div>
              <br />
              {data.citiesList && data.citiesList.length > 0 && (
                <section>
                  <div className="busSeoWrap__cityIndexSingleList">
                    {data.citiesList.map((cityData, idx) => (
                      <div
                        className="busSeoWrap__cityIndexSingleInfo"
                        key={idx}
                      >
                        <a href={cityData.url}>{cityData.name}</a>
                      </div>
                    ))}
                  </div>
                  <br />
                </section>
              )}
            </div>
            <br />

            {
              <Pagination
                currentPage={Number(data.pageOffset)}
                total={data.citiesCount}
                letter={data.letter}
                pageSize={Number(data.pageSize)}
                urlPrefix={urlPrefix}
              />
            }
          </main>
        </div>
        <FooterSection template={data.templateData} />
        <div
          className="blackOverlay"
          onClick={() => {
            setcollapsableFlag(true);
          }}
        ></div>
      </div>
    </>
  );
};
StaticListIndexSingle.fetchData = async (_, match, urlObj, gRPCClient) => {
  const {
    params: { page = 1 }
  } = match;

  const letter = match.params.letter
    ? urlObj.pathname
        .match(/[A-za-z]_[A-Za-z]/g)[0]
        .split('_')
        .map(s => s.toLowerCase())[1]
    : `a`;

  const pageSize = 250;
  const urlString = `${DATA_LOADER_URL}/api/getCitiesByStartingAlphabet?index=${letter}&pageOffset=${page}&pageSize=${pageSize}`;
  let responseData;
  const response = await fetch(urlString);
  const textResponse = await response.text();
  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new DataLoaderError(`Unable to fetch bus list`, responseData.error);
  }

  const pathArray = urlObj.path.split('/');
  const cacheKey =
    'HTML_STATIC_' + pathArray[pathArray.length - 1].toUpperCase();

  responseData.templateData.analytics = `<script type="text/javascript"> var s=s_gi('mmtprod');
    s.pageName="seo:domestic bus:index:city";
    s.channel="seo";
    s.eVar1= navigator.userAgent;
    s.server = window.location.hostname;
    s.prop24="domestic bus";               
    if(typeof(mboxLoadSCPlugin) != "undefined" ){
      mboxLoadSCPlugin(s);
    }
    var s_code=s.t();
    if(s_code)document.write(s_code);
    </script>
`;
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    letter,
    pageOffset: Number(page),
    pageSize,
    ...responseData
  };
};

export default StaticListIndexSingle;
